import { FluxStandardAction } from "__utils/type";
import * as Actions from "constants/actions";


export const fetchRiskProfileResult = (): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_RISK_PROFILE_RESULT,       
    }
};
export const fetchRiskProfileResultSuccess = (data: any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_RISK_PROFILE_RESULT_SUCCESS,
        payload: {
            data: data
        }
        
    }
};
export const fetchRiskProfileResultError = (error:any): FluxStandardAction => {
    return {
        type: Actions.FETCH_GET_RISK_PROFILE_RESULT_FAILURE,
        payload: {
            data: error
        }
        
    }
};

